import { SELECT_CALL_GROUP } from './typeConstants';

export const selectCallGroup = (data) => ({
    type: SELECT_CALL_GROUP,
    data,
});
